import 'zone.js';
// import 'core-js/es6/reflect';
import 'core-js/actual';

(window as any)['global'] = window;